import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../components/Header";
import Meta from "../../components/Meta";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faShareFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import {
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../api/firebase";
import { toast } from "react-toastify";
import axios from "axios";

const SweetSpotPages = () => {
  const pageTitle = "Sweet Spots";
  // const [pageDescription, setPageDescription] = useState("");

  const initDom: any = null;
  const [site, setSite] = useState(initDom);

  const params = useParams();
  const domainId = params.did ? params.did.toString() : "";

  const init: any[] = [];
  const [pages, setPages] = useState(init);

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleConfirm = () => {
    setShow(false);
    onCalculateHandler();
  };

  useEffect(() => {
    loadDomain();
  }, []);

  const loadDomain = async () => {
    const doDocRef = doc(db, "site_monitor", domainId);
    onSnapshot(doDocRef, (doc) => {
      const site = doc.data() as any;
      site.id = domainId;
      setSite(site);
    });
    loadPages();
  };

  const loadPages = async () => {
    const q = await getDocs(
      query(collection(db, "site_monitor/" + domainId + "/page_sweetspot"))
    );
    const objList: any[] = q.docs.map((doc: any) => {
      const obj = doc.data() as any;
      obj.id = doc.id;

      return obj;
    });

    setPages(
      objList.sort(function (a, b) {
        return b.impressions - a.impressions;
      })
    );
  };

  const onCalculateHandler = async () => {
    await updateDoc(doc(db, "site_monitor", site.id), {
      ssSumStatus: "validating",
      ssSumAt: "Validating...",
      ssSumRange: site.ssSumRange,
      ssPositionFrom: site.ssPositionFrom,
      ssPositionTo: site.ssPositionTo,
      ssImpGreaterThan: site.ssImpGreaterThan,
    });

    try {
      const r = await axios.post(
        process.env.REACT_APP_BACKEND_API_PATH + "gsc/calculateSweetSpot",
        { domainid: domainId, debug: 1 }
      );
      // const r = await axios.post(
      //   "http://localhost:5001/seo-header-tag/asia-southeast2/calculateSweetSpot",
      //   { domainid: domainId, debug: 1 }
      // );
      if (r.status === 200) {
        toast.success("This might take up to 5 - 30 minutes.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        await updateDoc(doc(db, "site_monitor", domainId), {
          ssSumStatus: "error",
          ssSumAt: "",
        });
      }
    } catch (e) {
      await updateDoc(doc(db, "site_monitor", domainId), {
        ssSumStatus: "error",
        ssSumAt: "",
      });

      toast.error("Error on calculating sweet spot", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    // recalculate();
  };

  return (
    <div>
      <Meta title={pageTitle} />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Configuration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {site && (
            <Form>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextEmail"
              >
                <Form.Label column sm="4">
                  Date Range
                </Form.Label>
                <Col sm="8">
                  <Form.Select
                    defaultValue={site.ssSumRange}
                    onChange={(e) => {
                      site.ssSumRange = e?.currentTarget?.value;
                    }}
                  >
                    <option value="last7days">Last 7 days</option>
                    <option value="last28days">Last 28 days</option>
                  </Form.Select>
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4">
                  Position Range
                </Form.Label>
                <Col sm="4">
                  <Form.Control
                    type="number"
                    placeholder="From"
                    defaultValue={site.ssPositionFrom}
                    onChange={(e) => {
                      site.ssPositionFrom = parseInt(e?.currentTarget?.value);
                    }}
                  />
                </Col>
                <Col sm="4">
                  <Form.Control
                    type="number"
                    placeholder="To"
                    defaultValue={site.ssPositionTo}
                    onChange={(e) => {
                      site.ssPositionTo = parseInt(e?.currentTarget?.value);
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4">
                  {"Impression >="}
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="number"
                    placeholder="imp greater & equal than"
                    defaultValue={site.ssImpGreaterThan}
                    onChange={(e) => {
                      site.ssImpGreaterThan = parseInt(e?.currentTarget?.value);
                    }}
                  />
                </Col>
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Save Config & Calculate
          </Button>
        </Modal.Footer>
      </Modal>
      {site && (
        <Card className="mb-2">
          <Card.Body>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 col-xl-8">
                <div>You are viewing</div>
                <div>
                  <h4 className="pt-3">{site.siteUrl}</h4>
                </div>
                <div>Sweet Spot</div>
                <div className="mt-3">
                  <Button
                    onClick={() => {
                      navigate("/domains");
                    }}
                    variant="primary"
                    size="sm"
                  >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                    Domains
                  </Button>
                </div>
              </div>
              <div className="col-12 col-md-3 col-lg-3 col-xl-2 text-secondary text-center d-flex align-items-center">
                <div>
                  <div>
                    {site.ssSumStatus === "never" && (
                      <>
                        <div
                          className="text-info"
                          style={{ fontSize: "1.2em", fontWeight: "bold" }}
                        >
                          Never Calculate
                        </div>
                        <div>Press "Generate" button</div>
                      </>
                    )}
                    {site.ssSumStatus === "error" && (
                      <>
                        <span
                          className="text-danger"
                          style={{ fontSize: "1.2em", fontWeight: "bold" }}
                        >
                          Error!
                        </span>
                      </>
                    )}
                    {site.ssSumStatus === "completed" && (
                      <>
                        <span
                          className="text-success"
                          style={{ fontSize: "1.2em", fontWeight: "bold" }}
                        >
                          Completed
                        </span>
                      </>
                    )}
                    {site.ssSumStatus === "pending" && (
                      <>
                        <Spinner
                          className="me-1"
                          variant="warning"
                          animation="grow"
                          size="sm"
                        />{" "}
                        <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                          Calculating
                        </span>
                      </>
                    )}
                    {site.ssSumStatus === "validating" && (
                      <>
                        <Spinner
                          className="me-1"
                          variant="info"
                          animation="grow"
                          size="sm"
                        />{" "}
                        <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                          Validating
                        </span>
                      </>
                    )}
                  </div>
                  {site.ssSumStatus !== "never" && (
                    <div className="pt-2" style={{ fontSize: "0.8em" }}>
                      Last updated
                    </div>
                  )}
                  <div style={{ fontSize: "0.8em", fontWeight: "bold" }}>
                    {site.ssSumAt ? site.ssSumAt : "-"}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-3 col-lg-3 col-xl-2 d-flex align-items-center">
                <div style={{ width: "100%" }}>
                  <div className="d-grid gap-2">
                    <Button
                      disabled={
                        site.ssSumStatus === "pending" ||
                        site.ssSumStatus === "validating"
                      }
                      onClick={() => {
                        handleShow();
                      }}
                      variant="success"
                      size="sm"
                    >
                      {site.ssSumStatus === "never" ? "Generate" : "Calculate"}
                    </Button>
                  </div>
                </div>
                {/* <div>

                </div> */}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
      {site && site.ssSumStatus === "never" && (
        <Alert className="mt-3" key="info" variant="info">
          Press "Generate" button to generate the first sweet spots data.
        </Alert>
      )}
      <Table className="mt-4" striped bordered>
        <thead>
          <tr>
            <th>SS Pages ({pages.length})</th>
            <th className="text-center">SS Keyword</th>
            <th className="text-center">Imps</th>
            <th className="text-center">Clicks</th>
            <th className="text-center">CTR %</th>
            {/* <th># of Keywords</th> */}
          </tr>
        </thead>
        <tbody>
          {pages.length === 0 && (
            <tr>
              <td className="text-center" colSpan={5}>
                No Data
              </td>
            </tr>
          )}
          {pages.map((page) => (
            <tr key={page.id}>
              <td>
                <Link
                  to={
                    "/sweet-spot/domain/" +
                    domainId +
                    "/page/" +
                    page.id +
                    "/keywords"
                  }
                >
                  {" "}
                  {page.page}{" "}
                </Link>
              </td>
              {/* <td>{page.keywords}</td> */}
              <td className="text-center text-danger">{page.sweetspots}</td>
              <td className="text-center">{page.impressions}</td>
              <td className="text-center">{page.clicks}</td>
              <td className="text-center">{page.ctr}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SweetSpotPages;
